import { GetFilmDetailReturnType } from '@/types';
import request from '../index';

export default {
    /**
     * @description 获取租户配置
     * @returns
     */
  async getleaseconfig() {
    const tempParams = {
      api: 'gop.alipic.icirena.own.lease.getleaseconfig',
    };
    return await request<GetFilmDetailReturnType>(tempParams);
  },
};
